import $ from 'jquery'
import 'slick-carousel'
import './slider'
import './modal'
import './offer'
import './form.js'
import './favorites.js'
import './video-play.js'
import './scroll-reveal'
window.$ = window.jQuery = $
